import {
	ConsumerSessionDataAction,
	CONSUMER_SESSION_ACTIONS,
} from '../../actions/consumerDataPullSessionActions/consumerSessionDataActions'
import { BankError } from '#modules/Bank/Bank.types'

const INITIAL_STATE = {
	reopeningSession: false,
	reopeningSessionError: null as BankError | null,
	reopeningSessionSuccessful: false,
}

export type ConsumerSessionDataState = typeof INITIAL_STATE

// Not using state machine pattern
export const consumerSessionDataReducer = (
	state: ConsumerSessionDataState = INITIAL_STATE,
	action: ConsumerSessionDataAction,
): ConsumerSessionDataState => {
	switch (action.type) {
		case CONSUMER_SESSION_ACTIONS.REOPEN_SESSION:
			return {
				...state,
				reopeningSession: true,
				reopeningSessionSuccessful: false,
				reopeningSessionError: null,
			}
		case CONSUMER_SESSION_ACTIONS.REOPEN_SESSION_FAILED:
			return {
				...state,
				reopeningSession: false,
				reopeningSessionError: action.reopenSessionError,
			}
		case CONSUMER_SESSION_ACTIONS.REOPEN_SESSION_SUCCEEDED:
			return {
				...state,
				reopeningSession: false,
				reopeningSessionSuccessful: true,
			}
		default:
			return state
	}
}
